import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AlertTriangle, ArrowRightLeft, Ban, Briefcase, CheckCircle2, CreditCard, FileWarning, History, Lock, RefreshCw, Timer,
} from 'lucide-react';
import api from '../../utils/axios';
import { PanelAnalisis } from './PanelAnalisis';

const ICONOS = {
  CVU_ALTA: { i: CreditCard, c: 'bg-sky-100 text-sky-700' },
  CVU_CAMBIO: { i: ArrowRightLeft, c: 'bg-indigo-100 text-indigo-700' },
  CVU_CAMBIO_SPONSOR: { i: RefreshCw, c: 'bg-amber-100 text-amber-700' },
  EPISODIO: { i: AlertTriangle, c: 'bg-orange-100 text-orange-700' },
  EPISODIO_VENCIDO: { i: Timer, c: 'bg-slate-100 text-slate-600' },
  EPISODIO_CERRADO: { i: CheckCircle2, c: 'bg-emerald-100 text-emerald-700' },
  CASO: { i: Briefcase, c: 'bg-violet-100 text-violet-700' },
  CASO_ESTADO: { i: History, c: 'bg-violet-50 text-violet-600' },
  BLOQUEO: { i: Lock, c: 'bg-red-100 text-red-700' },
  CIERRE: { i: Ban, c: 'bg-slate-200 text-slate-700' },
  ROS: { i: FileWarning, c: 'bg-rose-100 text-rose-700' },
};

const fecha = (f) => new Date(f).toLocaleString('es-AR', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

// D1 / F5: línea de tiempo del cliente. `soloCliente` deja altas y cambios de CVU o sponsor y episodios.
export const LineaTiempo = ({ cuit, soloCliente = false, eventosExtra = [], titulo = 'Línea de tiempo del cliente' }) => {
  const navigate = useNavigate();
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!cuit) { setLoading(false); return; }
    let vivo = true;
    setLoading(true);
    api.get(`/padron-interno/cliente/${cuit}/timeline`, { params: { solo_cliente: soloCliente } })
      .then((r) => vivo && setEventos(r.data.eventos || []))
      .catch(() => vivo && setError('No se pudo cargar la línea de tiempo'))
      .finally(() => vivo && setLoading(false));
    return () => { vivo = false; };
  }, [cuit, soloCliente]);

  const todos = [...eventos, ...eventosExtra].sort((a, b) => (b.fecha || '').localeCompare(a.fecha || ''));
  return (
    <PanelAnalisis titulo={titulo} icono={History} testid="linea-tiempo" loading={loading} error={error}
      vacio={!todos.length ? 'Sin eventos para este cliente' : null}
      extra={<span className="text-xs text-slate-400">{todos.length} eventos</span>}>
      <ol className="relative ml-3 border-l border-slate-200">
        {todos.map((e, idx) => {
          const cfg = ICONOS[e.tipo] || ICONOS.CASO_ESTADO;
          const Icono = cfg.i;
          return (
            <li key={`${e.tipo}-${e.fecha}-${idx}`} className="mb-3 ml-5" data-testid={`linea-tiempo-evento-${idx}`}>
              <span className={`absolute -left-3 flex h-6 w-6 items-center justify-center rounded-full ring-4 ring-white ${cfg.c}`}>
                <Icono size={12} />
              </span>
              <div className="flex flex-wrap items-baseline gap-x-3">
                <time className="font-mono text-[11px] text-slate-400">{fecha(e.fecha)}</time>
                {e.link ? (
                  <button type="button" onClick={() => navigate(e.link)} className="text-left text-sm text-slate-700 hover:text-sky-700 hover:underline">
                    {e.texto}
                  </button>
                ) : <span className="text-sm text-slate-700">{e.texto}</span>}
              </div>
            </li>
          );
        })}
      </ol>
    </PanelAnalisis>
  );
};

export default LineaTiempo;
